<div class="innovation-card">
  <div class="initiative" [ngClass]="{ completed: type === 'Completed' }">
    {{ initiativeData?.name }}
  </div>
  <div class="engagement">
    <label class="title">Engagement :</label>
    <label class="name">{{ initiativeData.engagementName }}</label>
  </div>
  <div class="content">
    <span>{{ initiativeData.shortDescription }}</span>
    <p>
      {{ initiativeData.longDescription }}
    </p>
  </div>
</div>
